import { StateNamesEnum } from '../../../enum/state-names-enum';

export class Breadcrumb {
    name: string;
    url: StateNamesEnum;
    backFunction: string;
}
